import { Icon } from '@chakra-ui/react';

const DEFAULT_FILL = '#F47467';
const DEFAULT_STROKE = 'url(#paint0_linear_9730_2663)';
const DEFAULT_MASK_STROKE = 'url(#paint1_linear_9730_2663)';

export const CustomSearchIcon = ({ color, ...props }) => {
  const fill = color ?? DEFAULT_FILL;
  const stroke = color ?? DEFAULT_STROKE;
  const maskStroke = color ?? DEFAULT_MASK_STROKE;

  return (
    <Icon viewBox="0 0 21 22" fill="none" {...props}>
      <path
        d="M11.3642 12.2958C13.7315 9.71577 13.7315 5.52603 11.3642 2.935C8.99703 0.355 5.15285 0.355 2.77552 2.935C0.408311 5.515 0.408311 9.70474 2.77552 12.2958C5.14273 14.8758 8.98692 14.8758 11.3642 12.2958Z"
        stroke="#989898"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6271 12.584L19.2144 20.8532"
        stroke="#989898"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
